export default __webpack_public_path__ + "static/18702-319ada7f9ebbc9ab7bde901a4c4f357f.jpg";